import { createAction } from '@reduxjs/toolkit';

import { MODULE_NAME } from './constants';

export const paymentMethodUpdated = createAction(
  `${MODULE_NAME}/paymentMethodUpdated`
);

export const hiringBoostAdded = createAction(`${MODULE_NAME}/hiringBoostAdded`);
